import React from "react";

interface SettingsIconProps extends React.SVGProps<SVGSVGElement> {
    size?: number;
    className?: string;
    color?: string;
}

const SettingsIcon: React.FC<SettingsIconProps> = ({ size = 16, className, color = '#292D32', strokeWidth = "1.3", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke={color} strokeWidth={strokeWidth} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.66699 10.7338V9.26718C1.66699 8.40052 2.37533 7.68385 3.25033 7.68385C4.75866 7.68385 5.37533 6.61718 4.61699 5.30885C4.18366 4.55885 4.44199 3.58385 5.20033 3.15052L6.64199 2.32552C7.30033 1.93385 8.15033 2.16718 8.54199 2.82552L8.63366 2.98385C9.38366 4.29218 10.617 4.29218 11.3753 2.98385L11.467 2.82552C11.8587 2.16718 12.7087 1.93385 13.367 2.32552L14.8087 3.15052C15.567 3.58385 15.8253 4.55885 15.392 5.30885C14.6337 6.61718 15.2503 7.68385 16.7587 7.68385C17.6253 7.68385 18.342 8.39218 18.342 9.26718V10.7338C18.342 11.6005 17.6337 12.3172 16.7587 12.3172C15.2503 12.3172 14.6337 13.3838 15.392 14.6922C15.8253 15.4505 15.567 16.4172 14.8087 16.8505L13.367 17.6755C12.7087 18.0672 11.8587 17.8338 11.467 17.1755L11.3753 17.0172C10.6253 15.7088 9.39199 15.7088 8.63366 17.0172L8.54199 17.1755C8.15033 17.8338 7.30033 18.0672 6.64199 17.6755L5.20033 16.8505C4.44199 16.4172 4.18366 15.4422 4.61699 14.6922C5.37533 13.3838 4.75866 12.3172 3.25033 12.3172C2.37533 12.3172 1.66699 11.6005 1.66699 10.7338Z" stroke={color} strokeWidth={strokeWidth} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />

    </svg>
);

export default SettingsIcon;
